import * as React from 'react';
import './ToggleModal.scss';
import useMobile from 'src/hooks/useMobile';
import Modal from 'src/components/common/Modal';
import Button from 'src/components/common/Button';

interface IToggleModalProps {
  handleGranted: () => void;
  handleCancel: () => void;
  t?: any;
}

const ToggleModal: React.FC<IToggleModalProps> = ({
  handleGranted,
  handleCancel,
  t
}) => {
  const isMobile = useMobile();

  return (
    <div className="rp-toggle-modal">
      <Modal
        handleCloseModal={handleCancel}
        showClose={false}
        styles={{
          backgroundColor: 'white',
          color: 'black',
          minHeight: 'unset',
          padding: '40px',
          width: isMobile ? '95%' : ''
        }}
      >
        <i className="rpds-error rp-modal-error-icon" />
        <p className="rp-modal-title">{t('myReturns.mustBeInseparateParts')}</p>
        <p className="rp-modal-text">{t('myReturns.unuseditemsinCart')}</p>
        <p className="rp-modal-text">{t('myReturns.ifContinuedloseItems')}</p>
        <div className="rp-modal-buttons-container">
          <Button
            label={(t('common.cancel') as string).toUpperCase()}
            buttonClass="secondary-button"
            action={handleCancel}
            width="50%"
            height="40px"
          />
          <Button
            label={(t('common.continueActionTxt') as string).toUpperCase()}
            buttonClass="primary-button"
            action={handleGranted}
            width="50%"
            height="40px"
          />
        </div>
      </Modal>
    </div>
  );
};

export default ToggleModal;
